<nav #header class="fixed-top headerStyle" style="background-color: #626672;filter: drop-shadow(1px 1px 1px #6666664d);"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}">
    <div style="border-bottom: 1px #FFFFFF4D solid;">
        <div class="container green">
            <div class="containerMenu navbar-collapse collapse">
                <div class="call-container">
                    <div>
                        <a href="https://api.whatsapp.com/send?phone=593993046283&text=Hi%20need%20info"
                            target="_blank"><i class="fa fa-phone-square" style="color: #287C0D;"></i></a>
                    </div>
                    <div class="logo-desktop">
                        <a href="https://www.toursingalapagos.com/" target="_blank">
                            <img class="logo" src="../assets/images/logos-header/gtg.svg" />
                        </a>
                    </div>
                    <div class="contactContainer">
                        <a href="https://www.toursingalapagos.com/" target="_blank"><i class="fa fa-align-right"
                                style="color: white;"></i></a>

                    </div>
                </div>
                <div class="contactMobile">
                    <span style="display: flex; align-items: center;">
                        <a href="https://www.facebook.com/gettravelgalapagos" target="_blank"><i
                                class="fa fa-facebook rrss-icons" style="color: white; padding-right: 5px;"></i></a>
                        <a href="https://www.instagram.com/get.travelgalapagos/" target="_blank"><i
                                class="fa fa-instagram rrss-icons" style="color: white;"></i></a>
                    </span>
                    <div style="display: flex; align-items: center;">
                        <a class="rightButton"
                            href="https://api.whatsapp.com/send?phone=593987568436&text=Hi%20need%20info"
                            target="_blank">
                            <span>BOOK NOW</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="menuButton">
                <a (click)="renderMenu()" href="javascript:void()" style="color: white; font-weight: bold;"><i
                        class="fa fa-bars" style="padding-right: 5px;"></i>Menu</a>
            </div>
        </div>
    </div>
    <div class="container green">
        <div class="containerHeader" [ngClass]="showMenu ? 'showMenu':''">
            <span style="display: flex; align-items: center;" class="desktop-rrss">
                <a href="https://www.facebook.com/gettravelgalapagos" target="_blank"><i
                        class="fa fa-facebook rrss-icons" style="color: white; padding-right: 5px;"></i></a>
                <a href="https://www.instagram.com/get.travelgalapagos/" target="_blank"><i
                        class="fa fa-instagram rrss-icons" style="color: white;"></i></a>
            </span>
            <ul class="navbar-nav desktop-list" [ngClass]="showMenu ? 'menu-backcolor':''">
                <li class="nav-item menuItem"><a href="https://www.toursingalapagos.com/" target="_blank">home</a>
                </li>
                <li class="nav-item menuItem"><a
                        href="https://www.toursingalapagos.com/tours/all-inclusive-tours-galapagos-islands"
                        target="_blank">tours</a></li>
                <li class="nav-item menuItem"><a
                        href="https://www.toursingalapagos.com/destinations/isabella-island-galapagos"
                        target="_blank">destinations</a></li>
                <li class="nav-item menuItem"><a href="https://www.toursingalapagos.com/hotels/twin-lodge-galapagos"
                        target="_blank">hotels</a></li>
                <li class="nav-item menuItem"><a href="https://www.toursingalapagos.com/travel-blogs"
                        target="_blank">blogs</a>
                </li>
                <li class="nav-item menuItem"><a
                        href="https://www.toursingalapagos.com/hotels/twin-lodge-galapagos#contactenosok"
                        target="_blank">contact us</a>
                </li>
                <li class="nav-item menuItem menuItemLast"><a href="https://www.toursingalapagos.com/"
                        target="_blank">language</a>
                </li>
                <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
                    <div class="wishlist tooltip-container">
                        <app-heart-header></app-heart-header>
                    </div>
                </li>
            </ul>
            <div style="display: flex; align-items: center;" class="desktop-booknow">
                <a class="rightButton" href="https://api.whatsapp.com/send?phone=593987568436&text=Hi%20need%20info"
                    target="_blank" style="color: white !important;">
                    <span>BOOK NOW</span>
                </a>
            </div>
        </div>
    </div>
</nav>